import { getOrganizationsList } from './organizationsApi';
import { Organization } from '../../components/common/ObjectTypes';
import { filter_page_size, page_size } from '../apiUtils';

let _cachedAllOrgs: Organization[] | null = null;
let _pendingAllOrgs: Promise<Organization[]> | null = null;

export const loadAllOrganizations = async (keycloak_token: string): Promise<Organization[]> => {
    if (_cachedAllOrgs) return _cachedAllOrgs;
    if (_pendingAllOrgs) return _pendingAllOrgs;

    _pendingAllOrgs = (async () => {
        try {
            let accumulated: Organization[] = [];
            let offset = 0;
            let hadError = false;
            while (true) {
                const [orgs, total, error] = await loadOrganizations(keycloak_token, offset, "", accumulated);
                if (error) { hadError = true; break; }
                accumulated = orgs;
                if (offset + filter_page_size >= total) break;
                offset += filter_page_size;
            }
            if (!hadError) _cachedAllOrgs = accumulated;
            return accumulated;
        } finally {
            _pendingAllOrgs = null;
        }
    })();

    return _pendingAllOrgs;
};

export const loadOrganizations = async (
    keycloak_token: string,
    page_offset: number,
    orgSearchInput: string,
    organizations: Organization[],
    org_table_page?: boolean
): Promise<[Organization[], number, Error | null]> => {
    let total_orgs = 0;
    try {
        const limit = org_table_page ? page_size : filter_page_size;
        const query = {
            limit: limit,
            offset: page_offset,
            search: orgSearchInput,
            ordering: 'name',
            previous: process.env.REACT_APP_BASE_URL_LOCAL + "/v2/organizations/?pager=limit&limit=" + limit + "&offset=" + (page_offset - limit),
            next: process.env.REACT_APP_BASE_URL_LOCAL + "/v2/organizations/?pager=limit&limit=" + limit + "&offset=" + (page_offset + limit)
        }
        const temp = await getOrganizationsList(keycloak_token, query);
        const new_array: Organization[] = org_table_page ? temp.results : organizations.concat(temp.results);
        const duplicates_removed: Organization[] = Array.from(new Set(new_array.map(obj => obj.id))).map(id => {
            return new_array.find(obj => obj.id === id)!;
        });
        const alphabetized = duplicates_removed.sort((a, b) => a.name.localeCompare(b.name));
        if (orgSearchInput.length === 0) total_orgs = temp.count;
        return [alphabetized, total_orgs, null]
    } catch (err: any) {
        console.log(err);
        return [[], 0, err];
    }
}